/**
 * summaryNext.js — TEST 3.12 (patient push 3a). Where "Continue" goes from a Describe summary
 * that was already submitted (currentCase.describeComplete, ViewSummary's `isLocked`).
 *
 * ★ THE DEFECT. The first visit to the summary offers the way forward (Prepare Case Report).
 *   Opened again later it offered only "Back to case": the submit block renders only for
 *   `userChoice === 'learn' && !isLocked`, and the footer had one button. Alex, 2026-09-30:
 *   "Das soll sich aendern" — a revisited summary also offers the way forward.
 *
 * ★ THE ONE RULE, stated by the row's interpretation (Alex may correct it at review):
 *   - not shared yet, Detect not done                                -> Detect (s98 order);
 *   - not shared yet, Detect done                                    -> the share fork;
 *   - a finished consult (completed, in follow-up, in observation)   -> Deliver;
 *   - shared, Detect done                                            -> Diagnose;
 *   - shared, Detect not done                                        -> Detect.
 *   "Shared" is read through caseShareState.js (shareCodeOf / hasClaimingDoctor), the owner of
 *   that fact, plus the statuses the server moves a sent case to. No second copy of the rule.
 *
 * Pure: no React, no store. scripts/check-locked-summary-next.mjs executes it.
 */
import { shareCodeOf, hasClaimingDoctor } from './caseShareState.js'

const DONE = new Set(['completed', 'in_follow_up', 'in_observation'])
const SENT = new Set(['shared', 'submitted', 'claimed', 'in_progress', 'scheduled', 'checked_in'])

/** Has this case gone to a doctor (a live code, a physician, or a sent status)? */
export function caseIsShared(c) {
  if (!c) return false
  return !!shareCodeOf(c) || hasClaimingDoctor(c) || SENT.has(c.status || '')
}

export function lockedSummaryNext(c) {
  if (!c) return { route: '/case/home' }
  const status = c.status || ''
  if (DONE.has(status)) return { route: '/case/deliver' }
  const shared = caseIsShared(c)
  // ★ s98 (Dr. Rami, 2026-10-07): Describe → Detect → share. An unshared case goes to Detect
  //   first, and to the share hub once Detect is done (D468).
  if (!shared) return { route: c.detectComplete ? '/case/share-hub' : '/case/detect' }
  return { route: c.detectComplete ? '/case/diagnose' : '/case/detect' }
}
